/* eslint-disable */
// shop page
// Show Filter column
//
import $ from "jquery";

const $productImage = $('.book');

export class WC_Image_Sticky {

  constructor() {

    // is the Shop element even here?
    if (!$('.book').length > 0) {
      return;
    }

    $(function () {
      if ($(window).width() < 693) {
        return;
      }

      $.fn.isInViewport = function() {
        const elementTop = $(this).offset().top;
        const elementBottom = elementTop + $(this).outerHeight();

        const viewportTop = $(window).scrollTop();
        const viewportBottom = viewportTop + $(window).height();

        return elementBottom > viewportTop && elementTop < viewportBottom;
      };

      let position = $(window).scrollTop();

      // should start at 0

      $(window).scroll(function() {
        const scroll = $(window).scrollTop();
        if (scroll > position) {
          // if scroll down
          $(window).on('resize scroll', function() {
            if (!$('.imageStop').isInViewport()) {
              $productImage.addClass('image-sticky');
            }
          });
        }
        position = scroll;
      });

    });
  }
}
